import IonIcon from '@reacticons/ionicons'
import React, { Dispatch, memo, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSubmitEnhancedRequestMutation } from 'src/graphql/generated/hooks'
import { showToast } from 'src/store/actions/toastAction'

import { UpgradeToEnhancedModal } from './UpgradeToEnhancedModal'

export const EnhancedRequestContainer = memo(({ solution_id }: { solution_id: string }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()
  const [showUpgradeToEnhancedModal, setUpgradeToEnhancedModal] = useState(false)

  const [submitEnhancedRequest] = useSubmitEnhancedRequestMutation()

  const requestUpgradeToEnhanced = async () => {
    try {
      const res = await submitEnhancedRequest({ variables: { solution_id: solution_id ?? '' } })
      if (res.data?.submitEnhancedRequest) dispatch(showToast('The request has been submitted', 'info'))
    } catch (error) {
      dispatch(showToast('An error occurred while submitting a request', 'error'))
    }
  }
  return (
    <div className="flex flex-row justify-center w-full">
      <div className="bg-fog rounded	w-[1080px] h-[100px] flex items-center mt-[30px] text-[16px] px-4 justify-between">
        <div className="flex items-center">
          <IonIcon className="text-black mr-2 text-[40px]" name={'alert-circle'} />
          If you would like to create an enhanced listing, please upgrade to enhanced <br />
          (Upgrading your listing to Enhanced or Premium improves your visibility on the site and enables you to share
          additional information such as videos, screenshots, and thought leadership.)
        </div>
        <button
          className="text-textdark font-secondary hover:bg-navy text-white py-2 px-3 rounded-full text-[14px] font-semibold transition-colors"
          onClick={() => setUpgradeToEnhancedModal(true)}
        >
          Upgrade to Enhanced
        </button>
        <UpgradeToEnhancedModal
          isOpen={showUpgradeToEnhancedModal}
          onClose={() => setUpgradeToEnhancedModal(false)}
          callback={requestUpgradeToEnhanced}
        />
      </div>
    </div>
  )
})
